<template>
    <v-card>
        <v-toolbar flat dark color="primary">
            <v-toolbar-title>{{ isNew ? 'Aggiungi nuova fase' : 'Modifica fase' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="!disabled && !isNewEntry" @click="confirmDelete" color="error" rounded small><v-icon
                    left>delete</v-icon>Elimina</v-btn>
            <v-switch v-else v-model="useTaskTemplate" :label="trans('projects.edit_task.use_task_template')" class="mt-4"></v-switch>
        </v-toolbar>

        <v-card-text>
            <item-selector
                v-if="useTaskTemplate"
                action="/task-templates/list"
                :label="trans('projects.edit_task.select_task_template')"
                item-text="name"
                item-value="id"
                v-model="taskTemplate"
                :rules="rules.required"
                v-bind="{ disabled, clearable:true, loading}"
                prepend-icon="person"
            ></item-selector>

            <v-form v-model="validForm">
                <v-text-field v-if="!useTaskTemplate" v-model="data.name" :rules="rules.name" label="Nome fase"
                    required></v-text-field>
                <v-text-field v-model="data.date_start" :rules="rules.date_start" type="date" label="Data inizio"
                    required></v-text-field>
                <v-text-field v-model="data.date_end" :rules="rules.date_end" type="date" label="Data fine"
                    required></v-text-field>
                <v-switch v-model="data.active" label="Attivo"></v-switch>

                <v-row v-if="subtaskTemplate.length > 0">
                    <v-col class="text-left">
                        <h4 >{{ trans('projects.edit_task.subtask_list') }}</h4>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn v-if="data.date_start && data.date_end" color="warning" rounded small @click="setDates()">{{trans('projects.edit_task.set_dates')}}</v-btn>
                    </v-col>
                    
                </v-row>
 
                <div v-for="(subtask, index) in subtaskTemplate" :key="index">
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                        <v-col><v-checkbox v-model="subtask.selected" :value="subtask.selected" :label="subtask.name" @change="addOrRemoveSubtask(subtask)"></v-checkbox></v-col>
                        <v-col><v-text-field v-model="subtask.date_start" :rules="getSubtaskRules(subtask).date_start" type="date" label="Data inizio"></v-text-field></v-col>
                        <v-col><v-text-field v-model="subtask.date_end" :rules="getSubtaskRules(subtask).date_end" type="date" label="Data fine"></v-text-field></v-col>
                    </v-row>
                </div>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn @click="$emit('close')"><v-icon left>close</v-icon>Annulla</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="save" :disabled="!canSubmit" color="primary"><v-icon left>save</v-icon>Salva</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { Vuelidator, Rule } from '../../Vuelidator/index.js';
import moment from 'moment';

function parseData(data) {
    return Object.assign({
        id: null,
        name: '',
        description: '',
        date_start: null,
        date_end: null,
        active: true,
        ///
        project_id: null,
        project: null,
        sub_tasks: [],
    }, data || {});
}

export default {
    props: {
        value: { type: Object, required: false },
    },
    data() {
        const data = parseData(this.value);

        const validator = new Vuelidator({
            name: [Rule.required(), Rule.min(3)],
            required: [Rule.required()],
            date_start: [Rule.required(), Rule.date()],
            date_end: [Rule.required(), Rule.date()],
        });
        const rules = validator.getRules();

        return {
            useTaskTemplate: false,
            taskTemplate: null,
            subtaskTemplate: [],
            validForm: false,
            loading: false,
            disabled: false,
            data,
            rules,
        
        }
    },
    computed: {
        canSubmit() {
            return this.validForm;
        },
        isNew() {
            return !this.data.id;
        },
        isNewEntry() {
            return this.value?.id === undefined;
        },
    },
    methods: {
        getSubtaskRules(subtask) {
            return {
            date_start: [
                value => {
                    if (!subtask.selected) return true;
                    if (!value) return 'La data inizio è obbligatoria';
                    if (!moment(value, 'YYYY-MM-DD', true).isValid()) return 'Data inizio non valida';
                    return true;
                }
            ],
            date_end: [
                value => {
                    if (!subtask.selected) return true;
                    if (!value) return 'La data fine è obbligatoria';
                    if (!moment(value, 'YYYY-MM-DD', true).isValid()) return 'Data fine non valida';
                    if (subtask.date_start && moment(value).isBefore(subtask.date_start)) return 'La data fine deve essere successiva alla data inizio';
                    return true;
                }
            ]
            };
        },
        setDates() {
            this.subtaskTemplate.forEach(st => {
                st.date_start = this.data.date_start;
                st.date_end = this.data.date_end;
            });
            this.data.sub_tasks.forEach(st => {
                const template = this.subtaskTemplate.find(t => t.name === st.name);
                if(template) {
                    st.date_start = template.date_start;
                    st.date_end = template.date_end;
                }
            });
        },
        populateSubtasks(template) {
            console.log(template);
            this.subtaskTemplate = (template.subtask_templates || []).map(st => ({
                name: st.name,
                description: st.description,
                date_start: this.data.date_start ?? null,
                date_end: this.data.date_end ?? null,
                selected: true,
                active: true,
            }));

            this.data.sub_tasks = this.subtaskTemplate.filter(st => st.selected).map(st => ({
                id: null,
                name: st.name,
                description: st.description,
                date_start: st.date_start,
                date_end: st.date_end,
                active: st.active,
                progress: 0,
                resources: [],
                sals: []
            }));
        },
        addOrRemoveSubtask(subtask) {
            if(subtask.selected) {
                this.data.sub_tasks.push({
                    id: null,
                    name: subtask.name,
                    description: subtask.description,
                    date_start: subtask.date_start,
                    date_end: subtask.date_end,
                    active: subtask.active,
                    progress: 0,
                    resources: [],
                    sals: []
                });
            } else {
                this.data.sub_tasks = this.data.sub_tasks.filter(st => st.name !== subtask.name);
            }
        },
        save() {
            this.$emit('save', this.data);
        },
        confirmDelete() {
            if (confirm('Confermi di voler cancellare il task selezionato e tutti i suoi sottotask e informazioni associate?')) {
                this.$emit('delete', this.value);
            }
        },
    },
    watch: {
        value() {
            this.data = parseData(this.value);
            this.useTaskTemplate = false;
        },
        useTaskTemplate() {
            this.taskTemplate = null;
            this.subtaskTemplate = [];
            this.data.name = null;
        },
        taskTemplate() {
            if(this.taskTemplate) {
                this.data.name = this.taskTemplate.name;
                this.populateSubtasks(this.taskTemplate);
            }
        }
    }
}
</script>